import { useEffect, useState } from 'react'
import { BalanceResult } from '../adapters/types'
import { useWeb3 } from './useWeb3'

export function useBalances(
  tokens: string[],
  address?: string,
): { balances: BalanceResult[]; loading: boolean } {
  const {
    address: connectedAddress,
    getBalances,
    isConnected,
    connect,
    hasPublicClient,
  } = useWeb3()
  const [balances, setBalances] = useState<BalanceResult[]>([])
  const [loading, setLoading] = useState(true)
  const theAddress = address || connectedAddress
  useEffect(() => {
    async function load() {
      setLoading(true)
      if (!getBalances) {
        return
      }
      if (!isConnected && (!address || !hasPublicClient)) {
        // If adapater doesn't have a public client and relies on the extension we need
        // to make sure it is connected
        connect()
        return
      }
      if (!theAddress) {
        return
      }

      const balances = await getBalances(tokens, theAddress)
      setBalances(balances)
      setLoading(false)
    }
    load()
  }, [tokens.sort().join(), theAddress, isConnected, hasPublicClient])

  return {
    balances,
    loading,
  }
}
